import { Text } from 'foundations-components/components/Text';
import { useMemo } from 'react';
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import styled from 'styled-components';
import { BreezeCaretStyle } from 'ai-components-ui-library/components/loading/BreezeLoadingDot';
import { LlmSanitizerConfig } from './LlmSanitizer';
import { jsx as _jsx } from "react/jsx-runtime";
const BACKTICK_REGEX = /`([^`]+)`/g;
const replaceBackticksWithCodeBlocks = text => text.replace(BACKTICK_REGEX, '<code class="inline-code-snippet" role="code">$1</code>');

/* @bend-expect no-styled-foundations-components */
const StyledText = styled(Text).withConfig({
  displayName: "Markdown__StyledText",
  componentId: "b0vil1-0"
})(["li > p{margin-bottom:0px;}> *:last-child{margin-bottom:0px;}"]);
const BreezeCaretText = styled(StyledText).withConfig({
  displayName: "Markdown__BreezeCaretText",
  componentId: "b0vil1-1"
})(["", ""], BreezeCaretStyle);
const Markdown = ({
  html,
  showTypingIndicator
}) => {
  const sanitizedHtml = useMemo(() => {
    return sanitize(html, LlmSanitizerConfig);
  }, [html]);
  const decoratedHtml = useMemo(() => {
    const htmlWithCodeDecorations = replaceBackticksWithCodeBlocks(sanitizedHtml);
    return htmlWithCodeDecorations;
  }, [sanitizedHtml]);
  const Component = showTypingIndicator ? BreezeCaretText : StyledText;
  return /*#__PURE__*/_jsx(Component, {
    as: "span",
    whiteSpace: "pre-line",
    "data-loading": showTypingIndicator,
    dangerouslySetInnerHTML: {
      __html: decoratedHtml
    }
  });
};
export default Markdown;